import { NextSeo } from 'next-seo';
import React from 'react';
import FlipsFeed from '../../components/FlipsFeed';
import PageHeader from '../../components/PageHeader';
import TheFlipsPage from '../../components/TheFlipsPage';
import config from '../../config';
import { FlipsProvider } from '../../hooks/useFlips';

function FlipsPage() {
  const title = `Shitty Flips - ${config.siteName}`;
  const description = `Flip a coin for double or nothing using Shitty Treats and other community tokens.`;

  return (
    <>
      <NextSeo title={title} description={description} />
      <div className='pb-12 md:pb-48 bg-bg'>
        <PageHeader heading={'Shitty Flips'} description={description} docsLink='https://docs.shittykitties.art/website-utilities/shitty-flips' />
        <div className='px-4 max-w-[85rem] lg:mx-auto lg:px-8'>
          <FlipsProvider>
            <>
              <TheFlipsPage />
              <FlipsFeed />
            </>
          </FlipsProvider>
        </div>
      </div>
    </>
  );
}

export default FlipsPage;
